import { render, staticRenderFns } from "./BodyWeight.vue?vue&type=template&id=5e478167"
import script from "./BodyWeight.vue?vue&type=script&lang=js"
export * from "./BodyWeight.vue?vue&type=script&lang=js"
import style0 from "./BodyWeight.vue?vue&type=style&index=0&id=5e478167&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports